import Api from "../utils/axios";
import { deliveryServer } from "../config/apiConfig";
 
export const DeliveryManApis={
    getAllDeliveryMan: (payload,search="") => Api.post(`delivery-personnel?search=${search}`,payload,{
      baseURL: deliveryServer,
      "headers":{
       'x-api-key' :'f0489b356902830b473e87805db59e0c64777953fac728516d9e29f8c6055ba4'
      }
    }),
    assignDeliveryMan: (payload)=>Api.post(`orders/assign-order-manually`,payload,{
      baseURL: deliveryServer,
      "headers":{
       'x-api-key' :'f0489b356902830b473e87805db59e0c64777953fac728516d9e29f8c6055ba4'
      }
    }),
    createOrderForDeliveryMan: (payload)=>Api.post(`orders`,payload,{
      baseURL: deliveryServer,
      "headers":{
       'x-api-key' :'f0489b356902830b473e87805db59e0c64777953fac728516d9e29f8c6055ba4'
      }
    })
  };